<template>
    <span class="ath-visual-entity-title">
        <span class="el-stencil el--t-txt" style="width: 12rem;"></span>
    </span>
</template>

<script>
export default {
    name: 'mead-entity-title-stencil',
};
</script>
